import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
})
export class TextareaComponent implements OnInit {
  @Input('form') form!: UntypedFormGroup;
  @Input('label') label!: string;
  @Input('infoText') infoText!: string;
  @Input('controlName') controlName: string = '';
  @Input('rows') rows: number = 4;
  @Input('requiredMessage') requiredMessage: string = 'This field is required';
  @Input('invalidMessage') invalidMessage: string = 'This field is invalid';
  @Input('disabled') disabled: boolean = false;
  @Input('matchMessage') maxlengthMessage: string = 'This field is too long';
  @Input() requiredMark: boolean = false;
  @Input('isHeader') isHeader: boolean = false;
  @Input('IsFormFieldNameHidden') IsFormFieldNameHidden = false;
  @Input('IsFromForm') IsFromForm:boolean = false;
  @Input('IsInfoVisible') IsInfoVisible:boolean = true;
  @Input('DisplayOnScreen') DisplayOnScreen:boolean = false;
  @Input('AllowMinimize') AllowMinimize:boolean = false;
  @Input('IsRowDisplayOnScreen') IsRowDisplayOnScreen:boolean = false;
  @Input('IsRichTextEditor') IsRichTextEditor:boolean = false;
  @Input() isRequired: boolean = false;
  @Input('errorMessagePrefix') errorMessagePrefix: string = '';

  isTextVisible:boolean = true
  required = false;
  inputId: string = '';
  editorConfig: AngularEditorConfig = {
    sanitize: false,
    editable: true,
    spellcheck: true,
    height: '10rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [['bold']],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };
  validator = Validators.required;

  constructor() {}

  ngOnInit(): void {
    // Generate unique ID for this textarea for label association
    this.inputId = `textarea-${this.controlName}-${Math.random().toString(36).substr(2, 9)}`;

    if (this.control?.errors?.required === true) this.required = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const disabled = changes?.disabled?.currentValue;
    if (disabled === false) {
      this.editorConfig = { ...this.editorConfig, editable: true, showToolbar: true  };
      this.control?.enable();
    } else if (disabled === true) {
      this.editorConfig = { ...this.editorConfig, editable: false, showToolbar: false };
      this.control?.disable();
    }
  }

  get control() {
    return this.form?.controls[this.controlName];
  }

  /**
   * Set errors here priority wise
   * @return error message
   */
  getErrorMessage = () => {
    if (this.control.hasError('maxlength')) return this.maxlengthMessage;
    if (this.control.hasError('required')) return this.requiredMessage;
    if (this.control.hasError('pattern')) return this.invalidMessage;
    return '';
  };

  toggleText(): void {
    this.isTextVisible = !this.isTextVisible;
  }

  hasErrors(): boolean {
    return !!(this.control && this.control.dirty && this.control.errors);
  }

  getAriaDescribedby(): string | null {
    const parts: string[] = [];

    if (this.hasErrors()) {
      parts.push(`${this.inputId}-error`);
    }

    if (this.infoText) {
      parts.push(`${this.inputId}-info`);
    }

    return parts.length > 0 ? parts.join(' ') : null;
  }
}
